import React from 'react';
import { useParams, withRouter } from 'react-router-dom';
import '../../../styles/report.scss';
import { getReport } from '../../../redux/methods/reports';
import useFetch from '../../../hooks/useFetch';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { SynchronizationReport } from '../../../features/reports/SynchronizationReport';

export function ReportPage({ getReport })
{
    const intl = useIntl();
    const translations = intl.messages.reports;
    const { reportId } = useParams();
    const [report] = useFetch(getReport, reportId, [reportId]);
    if (!reportId || !report) { return <div></div>; }
    const data = report ? JSON.parse(report.data) : null;
    const element =
    <Container fluid>
        <SynchronizationReport data={data} translations={translations} />
    </Container>;
    return element;
}

const mapDispatch =
{
    getReport
};

export default withRouter(connect(() => ({}), mapDispatch)(ReportPage));